// The CMS keeps the complete name: type - maker, optional region, state/country.
// Presentation fields remain linked to that name rather than duplicating CMS data.
export function splitWineName(name = "") {
  const value = String(name);
  const separator = value.indexOf(",");
  const parts = separator < 0
    ? { label: value.trim(), origin: "" }
    : { label: value.slice(0, separator).trim(), origin: value.slice(separator + 1).trim() };
  // "Riesling - Bex" → type "Riesling", maker "Bex". The maker joins the
  // origin line on the printed menu as "Bex · Nahe, Germany": the middle dot
  // keeps the maker distinct from the comma-separated region.
  const dash = parts.label.indexOf(" - ");
  parts.type = dash < 0 ? parts.label : parts.label.slice(0, dash).trim();
  parts.maker = dash < 0 ? "" : parts.label.slice(dash + 3).trim();
  parts.makerOrigin = [parts.maker, parts.origin].filter(Boolean).join(" · ");
  return parts;
}

export function updateWineName(name, field, text) {
  const parts = splitWineName(name);
  if (field === "wineLabel") {
    if (!text.trim() || text.includes(",")) throw new Error("Enter the wine type and maker here; edit the region below.");
    parts.label = text.trim();
  } else if (field === "wineType") {
    if (!text.trim() || text.includes(",") || text.includes(" - ")) throw new Error("Enter just the wine type here; the maker and region are on the line below.");
    parts.label = parts.maker ? `${text.trim()} - ${parts.maker}` : text.trim();
  } else if (field === "wineMaker") {
    if (text.includes(",") || text.includes(" - ")) throw new Error("Enter just the maker here; the region is the line's italic part.");
    parts.label = text.trim() ? `${parts.type} - ${text.trim()}` : parts.type;
  } else if (field === "wineMakerOrigin") {
    // "Maker · Region, Country". Without a dot, the first comma splits them.
    const dot = text.indexOf("·");
    const maker = (dot < 0 ? text.split(",")[0] : text.slice(0, dot)).trim();
    const region = (dot < 0 ? text.split(",").slice(1).join(",") : text.slice(dot + 1)).trim();
    parts.label = maker ? `${parts.type} - ${maker}` : parts.type;
    parts.origin = region;
  } else {
    parts.origin = text.trim();
  }
  return parts.origin ? `${parts.label}, ${parts.origin}` : parts.label;
}
